import AutoComplete from '@components/autocomplete'
import classnames from 'classnames'
import { Fragment, useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux"
import { formatCnpjCpf } from "../../../utility/formatCnpj"
import { useEmpresas } from "../../../Hooks/useEmpresa"
import { isUserLoggedIn } from "../../../utility/Utils"
import { Badge, Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap"
import { AlertTriangle, Bell, Check, LogOut, Menu, X } from "react-feather"
import { useRefreshToken } from "../../../Hooks/useRefreshToken"
import { logout } from "../../../redux/authentication"
import api from '../../../services/api'
import Avatar from '@components/avatar'

// ** Third Party Components
import PerfectScrollbar from 'react-perfect-scrollbar'


import "./styles.scss"
const CustomNavbar = (props) => {
  const { setMenuVisibility } = props
  const userState = useSelector(state => state.auth)
  const [suggestions, setSuggestions] = useState([])
  const [loading, setLoading] = useState(false)
  const [notification, setNotification] = useState([])
  const { handleEmpresa, currentEmpresa } = useEmpresas()
  const [width, setWidth] = useState(false)
  const [count, setCount] = useState(0)
  const dispatch = useDispatch()
  const { logoutRefresh } = useRefreshToken()
  const item = isUserLoggedIn()
  if (item !== null) {
    useEffect(() => {
      const { clientes } = userState.userData.user
      const clientesPesquisa = []
      clientes.map((item) => {
        const cnpj = formatCnpjCpf(item.cnpj)
        clientesPesquisa.push({ name: `${cnpj}, ${item.nome}, ${item.estado}` })
      })
      setSuggestions(clientesPesquisa)

      api.get('/perfil/notifications').then((response) => {
        const { data, count } = response.data
        setCount(count)
        setNotification(data)
        setLoading(true)
      })
    }, [])
  }

  async function handleSearch(querySearch) {
    await api.post('getSearchCNPJ', {
      query: querySearch
    }).then((response) => {
      const clientesSearch = response.data
      const clientesPesquisaAPI = []
      clientesSearch.map((item) => {
        const cnpj = formatCnpjCpf(item.cnpj)
        clientesPesquisaAPI.push({ name: `${cnpj}, ${item.nome}, ${item.estado}` })
      })
      setSuggestions(clientesPesquisaAPI)
    })
  }


  async function handleLogout() {
    await api.post('auth/logout').then((response) => {
      window.localStorage.removeItem('empresaSelecionada')
      document.cookie = `admin=true; path=/; max-age=0;`
      window.location = "/login"
      logoutRefresh()
      dispatch(logout())
    })
  }

  useEffect(() => {
    setWidth(window.innerWidth)
  }, [window.innerWidth])
  return (
    <>

      <div className={width > 1200 ? 'd-none' : ''} >
        <Menu className="icon-menu" onClick={() => { setMenuVisibility(true) }} />
      </div>
      {(isUserLoggedIn() !== null && userState.userData.user.tipo.toLowerCase() === "cliente") || (isUserLoggedIn() !== null && userState.userData.user.tipo.toLowerCase() === "sub-cliente") || (isUserLoggedIn() !== null && userState.userData.user.tipo.toLowerCase() === "sub-user") ? (
        <header className="header w-100 d-flex align-items-center justify-content-between">
          <UncontrolledDropdown className='dropdown-notification  nav-item'>
            <DropdownToggle tag='a' className='nav-link' href='/' onClick={e => e.preventDefault()}>
              <Bell size={21} />
              <Badge pill color='danger' className='badge-up'>
                {count}
              </Badge>
            </DropdownToggle>
            <DropdownMenu tag='ul' className='dropdown-menu-media '>
              <PerfectScrollbar className='media-list scrollable-container'>
                {loading ? notification.map((item) => {
                  return (
                    <DropdownItem key={item.id} className='item-notification ' tag="li">
                      <div className=''>
                        <Badge color={item.role_group === "captura" ? "light-primary" : "light-warning"}>{item.role_group}</Badge>
                        <p>{item.descricao}</p>
                      </div>
                    </DropdownItem>
                  )
                }) : null}
              </PerfectScrollbar>
            </DropdownMenu>
          </UncontrolledDropdown>
          <div className='container-input-empresa'>
            <AutoComplete
              suggestions={suggestions}
              className='form-control search-input-empresas text-center'
              filterKey='name'
              placeholder="Selecione uma empresa"
              defaultSuggestions={true}
              onChange={(e) => { handleSearch(e.target.value) }}
              value={currentEmpresa.name}
              customRender={(
                suggestion,
                i,
                filteredData,
                activeSuggestion,
                onSuggestionItemClick,
                onSuggestionItemHover
              ) => (
                <div key={suggestion} onClick={() => { handleEmpresa(suggestion) }}>
                  <li
                    className={classnames('suggestion-item d-flex justify-content-between li-empresas', {
                      active: filteredData.indexOf(suggestion) === activeSuggestion
                    })}
                    key={i}
                    onMouseEnter={() => onSuggestionItemHover(filteredData.indexOf(suggestion))
                    }
                    onClick={e => {
                      onSuggestionItemClick(null, e)
                    }}
                  >
                    <span><strong>{suggestion.name.split(',')[0]}</strong> {suggestion.name.split(',')[1]}</span>
                    <span className=" estado d-flex align-items-center justify-content-center">{suggestion.name.split(',').pop()}</span>
                  </li>
                </div>
              )}
            />
          </div>

          <Button onClick={handleLogout} color='primary' outline className='button-logout border-0 d-flex gap-1 align-items-center'> <LogOut size={18} /> {width < 650 ? null : <span>Sair</span>}</Button>
        </header>
      ) : isUserLoggedIn() !== null && userState.userData.user.tipo.toLowerCase() === "admin" ? <div className='w-100 container-button-navbar d-flex flex-row-reverse'>
        <Button onClick={handleLogout} color='primary' outline className='button-logout border-0 d-flex gap-1 align-items-center'> <LogOut size={18} /> {width < 650 ? null : <span>Sair</span>}</Button>
      </div> : "nao logado"}
    </>
  )
}

export default CustomNavbar
